import React from 'react';

const SvgWs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="WS_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="WS_svg__b" fill="#fff">
        <use xlinkHref="#WS_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#WS_svg__a" />
      <path fill="#E31F37" mask="url(#WS_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#083B9A"
        mask="url(#WS_svg__b)"
        d="M-1.333-1.333h16v12h-16z"
      />
      <path
        d="M6.667 9.333l-.943.276L6 8.667l-.276-.943.943.276.942-.276-.276.943.276.942-.942-.276zm0-6.666l-.943.276L6 2l-.276-.943.943.276.942-.276L7.333 2l.276.943-.942-.276zM4 6l-.943.276.276-.943-.276-.942.943.276.943-.276-.276.942.276.943L4 6zm6-.667l-.943.276.276-.942-.276-.943L10 4l.943-.276-.276.943.276.942L10 5.333zm-1.667 2a.333.333 0 1 1 0-.666.333.333 0 0 1 0 .666z"
        fill="#FFF"
        mask="url(#WS_svg__b)"
      />
    </g>
  </svg>
);

export default SvgWs;
